(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/match-view_desktop.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/match-view_desktop.js'); 
(function(Backbone, _, svs) {
  svs.tipset.views.MatchView = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.tipset.templates.matchview(data);
    },

    log: new svs.core.log.Logger('svs.tipset.views.MatchView'),

    modelEvents: {
      'change changeStatistics': 'showBigNav'
    },

    regions: {
      matchView: '.match-view'
    },

    bigNavOpen: false,

    initialize: function() {
      $(window).resize(function() {
        $(window.document).trigger('resizeTabView');

        if (svs.tipset && svs.tipset.multiSwiper) {
          setTimeout(function() {
            svs.tipset.multiSwiper.updateSize();
          }, 50);
        }
      });
    },

    clearSelectedMatch: function() {
      var drawUrlAddOn = svs.tipset.collections.draws
          .getCurrentDraw()
          .get('urlAddOn'),
        currentCompetitionUrl =
          svs.tipset.data.competition && svs.tipset.data.competition.clientUrl
            ? svs.tipset.data.competition.clientUrl + '/'
            : '';

      svs.tipset.views.matchview.model.clear({ silent: true });
      svs.tipset.collections.matchlist.trigger('currentMatchChanged', {
        eventNumber: -1
      });

      svs.obj.router.navigate(
        currentCompetitionUrl +
          drawUrlAddOn +
          (this.oldQuerystring || window.location.search),
        { trigger: false, replace: true }
      );

      $('#content-container').addClass('hide');
    },

    showBigNav: function() {
      this.bigNavOpen = false;

      var currentMatch = this.model.get('match'),
        navigateOptions = {
          trigger: svs.core.detect.formfactor.mobile(),
          replace: !svs.core.detect.formfactor.mobile()
        },
        self = this;

      if (currentMatch) {
        $('#content-container').removeClass('hide');

        currentMatch.league = currentMatch.league || {};
        currentMatch.league.sport = currentMatch.league.sport || {};

        if (_.isUndefined(currentMatch.league.sport.id)) {
          if (svs.tipset.data.gameDefinitions.apiName === 'POWERPLAY') {
            currentMatch.league.sport.id = 1000003;
            currentMatch.league.sport.name = 'Ishockey';
          } else {
            currentMatch.league.sport.id = 1000002;
            currentMatch.league.sport.name = 'Fotboll';
          }
        }

        this.statisticsModel = new svs.statistics.big.models.BigStatisticsModel(
          {
            match: currentMatch,
            draw: this.model.get('currentRound'),
            showBackButton: false,
            updateResult: false,
            updateOdds: false,
            showOdds: true,
            showPlayNow: false,
            showRegCloseTime: false
          }
        );

        if (!this.bigStatView) {
          this.bigStatView = new svs.statistics.big.views.NavBigStatisticsView({
            showCloseButton: true,
            animateTo: 'right'
          });
          this.bigStatView.on('bigNav:animate-out-complete', function() {
            self.clearSelectedMatch();
          });

          if (svs.tipset.productBase) {
            svs.tipset.productBase.on('tabChanged', function() {
              self.oldQuerystring = null;

              if (self.bigStatView.model.get('history').length > 0) {
                self.bigStatView.trigger('closeRegionStandard', {
                  event: 'animate-out-complete'
                });
              }
            });
          }
        }

        this.getRegion('matchView').show(this.bigStatView);

        this.oldQuerystring = this.oldQuerystring || window.location.search;

        this.bigStatView.trigger('show-match', {
          matchId: this.statisticsModel.get('match').matchId,
          model: this.statisticsModel,
          path: true,
          selectedTab: svs.tipset.data.params.tab
            ? svs.tipset.data.params.tab
            : ''
        });

        svs.core.data.title = svs.core.data.title || {};
        svs.core.data.title = _.extend(svs.core.data.title, {
          eventDescription: this.model.get('eventDescription')
        });
        var newUrl = this.model.fixURL();
        if (newUrl.indexOf('?') === -1) {
          newUrl += location.search;
        }

        svs.obj.router.navigate(newUrl, navigateOptions);

        this.listenTo(this.bigStatView, 'bigNav:openRegionDone', function() {
          self.bigNavOpen = true;
        });
      }
    }
  });
})(Backbone, _, svs);

 })(window);